export default "__VITE_ASSET__BVZuHHfL__"